import { create } from "zustand";

type ScrollState = {
  firstSectionRef: React.RefObject<HTMLElement> | null;
  secondSectionRef: React.RefObject<HTMLElement> | null;
  thirdSectionRef: React.RefObject<HTMLElement> | null;
  scrollToFirstSection: () => void;
  scrollToSecondSection: () => void;
  scrollToThirdSection: () => void;
  setFirstSectionRef: (ref: React.RefObject<HTMLElement>) => void;
  setSecondSectionRef: (ref: React.RefObject<HTMLElement>) => void;
  setThirdSectionRef: (ref: React.RefObject<HTMLElement>) => void;
};

export const useScrollStore = create<ScrollState>((set) => ({
  firstSectionRef: null,
  secondSectionRef: null,
  thirdSectionRef: null,

  scrollToFirstSection: () => {
    const firstSectionRef = useScrollStore.getState().firstSectionRef;
    if (firstSectionRef?.current) {
      firstSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  },

  scrollToSecondSection: () => {
    const secondSectionRef = useScrollStore.getState().secondSectionRef;
    if (secondSectionRef?.current) {
      secondSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  },

  scrollToThirdSection: () => {
    const thirdSectionRef = useScrollStore.getState().thirdSectionRef;
    if (thirdSectionRef?.current) {
      thirdSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  },

  setFirstSectionRef: (ref: React.RefObject<HTMLElement>) => set({ firstSectionRef: ref }),
  setSecondSectionRef: (ref: React.RefObject<HTMLElement>) => set({ secondSectionRef: ref }),
  setThirdSectionRef: (ref: React.RefObject<HTMLElement>) => set({ thirdSectionRef: ref }),
}));
